import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";
import Activity from "../../models/Activity";

export default function ActivitiesManagementPage() {
    const location = useLocation();
    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();
    const [activities, setActivities] = useState([]);
    const [filteredActivities, setFilteredActivities] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterType, setFilterType] = useState("all");

    // جلب النشاطات من السيرفر
    const fetchActivities = async () => {
        try {
            const res = await backEnd_request.get("/Activities");
            const data = res.data.data;
            setActivities(data.map(a => new Activity(a)));
            setFilteredActivities(data.map(a => new Activity(a)));
        } catch (error) {
            console.log(error.response?.data || error);
        }
    };

    useEffect(() => {
        fetchActivities();
    }, []);

    // تصفية النشاطات
    const handleSearch = (term, type) => {
        setSearchTerm(term);
        setFilterType(type);

        const filtered = activities.filter((act) => {
            if (!term.trim()) return true;
            switch (type) {
                case "activityType":
                    return act.activityType?.toLowerCase().includes(term.toLowerCase());
                case "activitySpecialty":
                    return act.activitySpecialty?.toLowerCase().includes(term.toLowerCase());
                case "assignedBy":
                    return act.createdByUsername?.toLowerCase().includes(term.toLowerCase());
                default:
                    return (
                        act.activityType?.toLowerCase().includes(term.toLowerCase()) ||
                        act.activitySpecialty?.toLowerCase().includes(term.toLowerCase()) ||
                        act.createdByUsername?.toLowerCase().includes(term.toLowerCase())
                    );
            }
        });

        setFilteredActivities(filtered);
    };

    // حذف النشاط
    const handleDelete = async (activityId) => {
        if (window.confirm("هل أنت متأكد من حذف هذا النشاط؟")) {
            try {
                await backEnd_request.delete(`/Activities/${activityId}`);
                fetchActivities();
                setDeleteSuccessMessage("تم حذف النشاط بنجاح ✅");
                setTimeout(() => setDeleteSuccessMessage(""), 3000);
            } catch (error) {
                console.log(error.response?.data || error);
            }
        }
    };

    return (
        <div className="container py-5">

            {/* العنوان + زر الإضافة */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="fw-bold text-primary">إدارة النشاطات</h3>
                <button
                    className="btn btn-success"
                    onClick={() => navigate("/admin/activities-management/create")}
                >
                    <i className="bi bi-plus-circle"></i> إضافة نشاط
                </button>
            </div>

            {/* رسائل النجاح */}
            {successMessage && <div className="alert alert-success text-center fw-bold">{successMessage}</div>}
            {deleteSuccessMessage && <div className="alert alert-success text-center fw-bold">{deleteSuccessMessage}</div>}

            {/* أدوات البحث */}
            <div className="card shadow-sm mb-4 p-3">
                <div className="row g-3 align-items-center">
                    <div className="col-md-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="اكتب هنا للبحث..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value, filterType)}
                        />
                    </div>
                    <div className="col-md-3">
                        <select
                            className="form-select"
                            value={filterType}
                            onChange={(e) => handleSearch(searchTerm, e.target.value)}
                        >
                            <option value="all">كل الحقول</option>
                            <option value="activityType">نوع النشاط</option>
                            <option value="activitySpecialty">تخصص النشاط</option>
                            <option value="assignedBy">المسؤول عن الإضافة</option>
                        </select>
                    </div>
                    <div className="col-md-2">
                        <button
                            className="btn btn-outline-secondary w-100"
                            onClick={() => {
                                setSearchTerm("");
                                setFilteredActivities(activities);
                            }}
                        >
                            إعادة تعيين
                        </button>
                    </div>
                </div>
            </div>

            {/* الجدول */}
            <div className="table-responsive shadow-sm">
                <table className="table table-hover align-middle text-center">
                    <thead className="table-primary">
                        <tr>
                            <th style={{ minWidth: "150px" }}>نوع النشاط</th>
                            <th style={{ minWidth: "100px" }}>عدد المنشآت</th>
                            <th style={{ minWidth: "100px" }}>الحالة</th>
                            <th style={{ minWidth: "100px" }}>إجراءات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredActivities.length > 0 ? (
                            filteredActivities.map((act) => (
                                <tr key={act.activityId}>
                                    <td
                                        className="text-primary fw-bold"
                                        style={{ cursor: 'pointer', textDecoration: 'none' }}
                                        onClick={() => navigate(`/admin/establishments-list?activityType=${encodeURIComponent(act.activityType)}`)}
                                    >
                                        {act.activityType}
                                    </td>
                                    {/* <td className="text-truncate" style={{ maxWidth: "150px" }}>{act.activityType}</td> */}
                                    <td>{act.establishmentsCount || "-"}</td>
                                    <td>
                                        <span className={`badge ${act.isActive ? "bg-success" : "bg-secondary"}`}>
                                            {act.isActive ? "نشط" : "غير نشط"}
                                        </span>
                                    </td>
                                    <td>

                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => navigate(`/admin/activities-management/edit/${act.activityId}`)}
                                        >
                                            تعديل
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => handleDelete(act.activityId)}
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-muted py-4">
                                    لا توجد بيانات لعرضها
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
